import { UserAccessCustomState } from "./UserAccessCustomState"; 

export const useInvoiceTotalOutstanding = () => {
  return UserAccessCustomState(14); //"Invoice Total OutStanding"
};

export const useInvoicePayNow = () => {
  return UserAccessCustomState(13) //"Invoice Pay Now"
};

export const useAddStaff = () => {
  return UserAccessCustomState(9) //"Add Staff"
};

export const useEditStaff = () => {
  return UserAccessCustomState(8) //"Edit Staff"
};

export const useSendWSReportOnEmail = () => {
  return UserAccessCustomState(10) //"Send Email- Patient Report" Changed to Send_WS_Report_On_Email
};

// export const useSendReportOnEmail = () => {
//   return UserAccessCustomState(10) //"Send Email- Patient Report" Changed to Send_WS_Report_On_Email
// };

export const useBulkPatientReportDownload = () => {
  return UserAccessCustomState(11) //"Bulk Report Download - Patient Report" //Change name in db
};

export const useDownloadWOSReport = () => {
  return UserAccessCustomState(5) //"WOS Report Download- Patient Report"
};

export const useDownloadWSReport = () => {
  return UserAccessCustomState(6) //"WS Report Download- Patient Report"
};

export const useDownloadInvoiceReport = () => {
  return UserAccessCustomState(12) //"Download Invoice Report"
};

export const useRateCardRights= () => {
  return UserAccessCustomState(7) //"Download Invoice Report"
};

export const useDownloadPatientListExcelRights= () => {
  return UserAccessCustomState(15) //"Download Patient List Excel"
};

export const useRechargeRights= () => {
  return UserAccessCustomState(16) //"Recharge"
};

export const useRaiseComplaintRights= () => {
  return UserAccessCustomState(17) //"Raise Complaint"
};

export const useSendWOSReportOnEmail= () => {
  return UserAccessCustomState(19) //"Send_WOS_Report_On_Email"
};

export const usePayReceiptRights= () => {
  return UserAccessCustomState(20) //"Pay Receipt"
};
